// extracted by mini-css-extract-plugin
export var deliveryRow = "_l4-a";
export var fixedHeight = "_l4-4";
export var freightLogo = "_l4-9";
export var fullWidth = "_l4-3";
export var priceColumn = "_l4-5";
export var radioSelected = "_l4-7";
export var radioUnselected = "_l4-6";
export var selectedOption = "_l4-2";
export var selectedOptionContainer = "_l4-1";
export var selection = "_l4-0";
export var tallSkeletonText = "_l4-8";